"use client";

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import RecentTripRow from "./RecentTripRow";
import { useEffect, useRef, useState } from "react";
import { getTripList } from "@/lib/actions/trip.actions";
import MyMap from "./MyMap";
import { Pagination } from "./Pagination";

const UPDATE_INTERVAL = 6 * 60 * 1000;

const TripsTable = ({
  trips,
  page,
  trips_filter,
  loggedIn = null,
  totalPages = 0,
}: TripTableProps) => {

  const getIntervalDuration = (trips:Trip[]) => {
    if (!trips || !trips.length) return UPDATE_INTERVAL;  //empty array
    const minimumDurationInTripsInSeconds = trips.reduce((prev, curr) => {return prev < curr.trip_state_duration ? prev : curr.trip_state_duration},UPDATE_INTERVAL);
    return Math.max(15*1000, minimumDurationInTripsInSeconds*1000);
  }
  
  const [localTrips, setLocalTrips] = useState<Trip[]>(trips);
  const initial_interval_duration = getIntervalDuration(trips);

  const interval_duration2 = useRef(initial_interval_duration);
  const nextRefreshTime2 = useRef(0);

  useEffect(() => {
    setLocalTrips(trips);
  }, [trips]);  //when trips update, update localTrips

  useEffect(() => {

    if (trips_filter === "history") return;

    const refreshFunction = async () => {

      if (!interval_duration2.current) return;//should not happen

      if (nextRefreshTime2.current > Date.now()) {//waiting
        console.log('refreshFunction/waiting', {wait: nextRefreshTime2.current - Date.now()});
        return;
      }
              
      try {
        const { data }: ResultApiRecenTrips = (await getTripList({ page, trips_filter })) || {};
        if (data != null) {
          console.log('REFRESHING', {data});
          const new_interval_duration = getIntervalDuration(data);
          interval_duration2.current = new_interval_duration;
          nextRefreshTime2.current = Date.now() + new_interval_duration;
          setLocalTrips(data);
        } else {
          console.log('refreshFunction/no data');
          interval_duration2.current = UPDATE_INTERVAL;
          nextRefreshTime2.current = Date.now() + UPDATE_INTERVAL;
        } 
      } catch (error) {
        console.log("refreshFunction/no data/error", error);
        interval_duration2.current = UPDATE_INTERVAL;
        nextRefreshTime2.current = Date.now() + UPDATE_INTERVAL;
      }
    };

    nextRefreshTime2.current = 0;

    //put in place the updatef
    const intervalId = setInterval(() => {
      refreshFunction();
    }, 5*1000);
    return () => clearInterval(intervalId);
  }, [trips_filter, trips]);


  return (
    <div className="flex flex-col items-center">
      <Table>
        <TableHeader className="bg-[#f9fafb]">
          <TableRow>
            <TableHead className="px-2">Date</TableHead>
            <TableHead className="px-2">Description</TableHead>
            <TableHead className="px-2">Statut</TableHead>
            <TableHead className="px-2 max-md:hidden">Chauffeur</TableHead>
            <TableHead className="px-2 max-md:hidden"></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {localTrips.map((trip: Trip) => (
            <RecentTripRow
              key={trip.course_token}
              localTrip={trip}
              // updateRegularly={true}
              // updateTrip={updateTrip}
            />
          ))}
        </TableBody>
      </Table>

      <Pagination page={page} totalPages={totalPages} />

      {trips_filter === "recent" && loggedIn && (
        <div className="hidden xl:flex">
          <MyMap
            center_lat={loggedIn.center_lat}
            center_lng={loggedIn.center_lng}
            width={800}
            height={400}
            trips={localTrips}
          />
        </div>
      )}
    </div>
  );
};

export default TripsTable;
